import { mockData } from '../../mock';
import { DEFAULT_THEME_OPTIONS } from '../../constants/themeOptions';
import { DEFAULT_ENABLED_LANGUAGE_CODES, LANGUAGES } from '../../context/LanguageContext';

export const LOGIN_PROVIDER_OPTIONS = [
  ['google', 'Google', 'large'], ['snapchat', 'Snapchat', 'large'], ['discord', 'Discord', 'small'],
  ['x', 'X', 'small'], ['spotify', 'Spotify', 'small'], ['github', 'GitHub', 'small'],
  ['twitch', 'Twitch', 'small'], ['tiktok', 'TikTok', 'small'], ['dropbox', 'Dropbox', 'small'], ['yahoo', 'Yahoo', 'small'],
];
export const DEFAULT_LOGIN_METHODS = LOGIN_PROVIDER_OPTIONS.map(([provider, , size], index) => ({
  provider,
  enabled: true,
  size,
  order: LOGIN_PROVIDER_OPTIONS.slice(0, index).filter(([, , previousSize]) => previousSize === size).length + 1,
  logo: '',
  color: '',
}));

export const DEFAULT_SITE_CONTENT = {
  eventName: 'REFUEL WEEKEND 27',
  eventDate: '2.–4. april',
  venue: 'Hjeltefjorden Arena',
  tagline: 'Bli med på ei spennande helg i Øygarden – ein plass der du kan lære og oppleve tro, fellesskap, lovsang, konsert og møte nye folk.',
  heroImage: '',
  logoImage: '',
  seoTitle: 'Refuel Weekend 2027 | Offisiell nettside',
  seoDescription: 'Refuel Weekend 2027 – ungdomshelg i Hjeltefjorden Arena, Øygarden, 2.–4. april 2027. Program, talarar, aktivitetar, overnatting og påmelding. Offisiell nettside for Refuel Weekend.',
  enabledLanguages: DEFAULT_ENABLED_LANGUAGE_CODES,
  loginMethods: DEFAULT_LOGIN_METHODS,
  primaryButton: 'Meld deg på',
  secondaryButton: 'Sjå trailer',
  contactButton: 'Kontakt Oss',
  promoEyebrow: 'Trailer 2027',
  promoHeading: 'Sjå kva som ventar deg',
  promoVideo: '',
  promoPoster: '',
  navLinks: mockData.navLinks,
  venues: mockData.venues,
  socials: mockData.socials,
  footerDescription: 'Refuel Weekend – ei helg fylt med tro, fellesskap og musikk. Vi sjåast i Øygarden 2.–4. april.',
  footerLinks: [
    { label: 'Aktivitetar', href: '/aktiviteter' },
    { label: 'Galleri', href: '/galleri' },
    { label: 'Videoar', href: '/videoar' },
    { label: 'Anmeldingar', href: '/anmeldelser' },
    { label: 'Spørsmål?', href: '/sporsmal' },
  ],
  themeOptions: DEFAULT_THEME_OPTIONS,
  creditName: 'Tristan Husebø Hagen',
  creditAgency: 'Norevio',
  creditUrl: 'https://norevio.site',
};

export const SITE_CONTENT_SCHEMA = [
  { key: 'eventName', label: 'Arrangementnamn' },
  { key: 'eventDate', label: 'Dato' },
  { key: 'venue', label: 'Stad' },
  { key: 'tagline', label: 'Tekst på framsida', type: 'textarea', rows: 3 },
  { key: 'heroImage', label: 'Bakgrunnsbilete på framsida', type: 'image' },
  { key: 'logoImage', label: 'Logo', type: 'image' },
  { key: 'seoTitle', label: 'SEO-tittel' },
  { key: 'seoDescription', label: 'SEO-skildring', type: 'textarea', rows: 3 },
  { key: 'enabledLanguages', label: 'Språk i språkveljaren', type: 'multiselect', options: LANGUAGES.filter((language) => language.code !== 'nn').map((language) => [language.code, `${language.label} (${language.short})`]), help: 'Vel kva språk som skal vere tilgjengelege på heile nettsida. Nynorsk er alltid tilgjengeleg.' },
  { key: 'primaryButton', label: 'Primærknapp' },
  { key: 'secondaryButton', label: 'Trailerknapp' },
  { key: 'contactButton', label: 'Kontaktknapp' },
  { key: 'promoEyebrow', label: 'Trailer – overtekst' },
  { key: 'promoHeading', label: 'Trailer – overskrift' },
  { key: 'promoVideo', label: 'Videolenke' },
  { key: 'promoPoster', label: 'Trailer – plakatbilete', type: 'image' },
  { key: 'navLinks', label: 'Menylenker', type: 'list', itemLabel: 'menylenke', schema: [
    { key: 'label', label: 'Namn' }, { key: 'href', label: 'Lenke (t.d. #program eller /galleri)' },
  ] },
  { key: 'venues', label: 'Stader og overnatting', type: 'list', itemLabel: 'stad', schema: [
    { key: 'name', label: 'Namn' }, { key: 'link', label: 'Lenke' },
    { key: 'image', label: 'Bilete', type: 'image' }, { key: 'description', label: 'Skildring', type: 'textarea', rows: 3 },
  ] },
  { key: 'socials', label: 'Sosiale lenker', type: 'list', itemLabel: 'lenke', schema: [
    { key: 'name', label: 'Namn (Instagram, Facebook, TikTok eller Mail)' }, { key: 'href', label: 'Adresse' },
  ] },
  { key: 'footerDescription', label: 'Botntekst', type: 'textarea', rows: 2 },
  { key: 'footerLinks', label: 'Lenker i botnteksten', type: 'list', itemLabel: 'lenke', schema: [
    { key: 'label', label: 'Namn' }, { key: 'href', label: 'Adresse' },
  ] },
  { key: 'themeOptions', label: 'Fargetema', type: 'list', itemLabel: 'fargetema', schema: [
    { key: 'value', label: 'ID (små bokstavar, t.d. teal)' },
    { key: 'label', label: 'Namn i menyen' },
    { key: 'color', label: 'Aksentfarge', type: 'color' },
    { key: 'logoImage', label: 'Logo – ståande', type: 'image' },
    { key: 'logoWideImage', label: 'Logo – brei', type: 'image' },
  ] },
  { key: 'creditName', label: 'Namn i kreditering' },
  { key: 'creditAgency', label: 'Firma i kreditering' },
  { key: 'creditUrl', label: 'Lenke til firma' },
];

export const THEME_OPTIONS_SCHEMA = SITE_CONTENT_SCHEMA.filter((field) => field.key === 'themeOptions');